import React, {useState} from "react";
import Sizes from "../Assets/Sizes";
import {FormattedMessage} from "react-intl";
import styled from "styled-components";
import {Button} from "rmwc";
import InputPart from "./InputWithLabel";
import {isFunction} from "@tomeravni/easybizy-js-common/common";

const Cmp = styled.div`
    display: flex;
    gap: ${Sizes.defaultPadding};
    opacity: ${p => p.disabled ? 0.3 : 1};
`;

const ButtonWrapper = styled.div`
    height: 30px;
`;

const SubmitButton = styled(Button)`
    --mdc-theme-primary: ${p => p.theme.colors.primaryText};
    left: 0;
    bottom: 0;
    color: ${p => p.theme.colors.primaryText};
    font-size: 20px;
    font-family: inherit;


    &[disabled] {
        opacity: 0.3;
        border-color: ${p => p.theme.colors.primaryText};
        color: ${p => p.theme.colors.primaryText};
    }
`;

const SingleLineInput = ({
                             inProgress,
                             value,
                             label,
                             pattern,
                             autoComplete,
                             onSubmit,
                             disabled,
                             wrapperOnClick,
                             validateAdaptValue,
                             validityStatusChange: externalValidityStatusChange,
                             onChange: externalOnChange = () => {
                             },
                             isFocused,
                             inputType,
                             inputFont
                         }) => {
    const inputPartRef = React.useRef(null);
    const wrapperClicked = wrapperOnClick || (() => {
    });

    const [isValid, setIsValid] = useState(false);
    const validityStatusChange = (iIsValid) => {
        setIsValid(iIsValid);
        if (isFunction(externalValidityStatusChange)) {
            externalValidityStatusChange(iIsValid);
        }
    }

    const onChange = (newValue) => {
        externalOnChange(newValue);
    }

    function handleButtonClick() {
        if (isValid) {
            onSubmit(inputPartRef.current.getValue());
        }
    }

    return (
        <Cmp disabled={disabled}>
            <InputPart
                inputType={inputType}
                inputFont={inputFont}
                inProgress={inProgress}
                value={value}
                pattern={pattern}
                disabled={disabled}
                autoComplete={autoComplete}
                onChange={onChange}
                ref={inputPartRef}
                label={label}
                onSubmit={onSubmit}
                isFocused={isFocused}
                validateAdaptValue={validateAdaptValue}
                validityStatusChange={validityStatusChange}
            />

            <ButtonWrapper onClick={() => wrapperClicked(isValid)}>
                <SubmitButton
                    outlined
                    disabled={inProgress || !isValid || disabled}
                    onClick={handleButtonClick}
                >
                    <FormattedMessage id="app.send"/>
                </SubmitButton>
            </ButtonWrapper>
        </Cmp>
    );
};

export default SingleLineInput;

